import $ from "jquery";
const defaultConfig = {
  nav: ".js-searching-nav",
  selector: ".js-searching-nav .js-searching-nav-trigger",
  filterableSelector: ".js-searching-filterable",
  noResultsElement: ".js-searching-no-results"
};
export function LetterFilterDictionary({
  selector,
  filterableSelector,
  noResultsElement,
  nav
} = defaultConfig) {
  const $elements = $(selector);
  const $filterables = $(filterableSelector);
  const BUTTON_ACTIVE_CLASS = "is-active";
  function handleClick(e) {
    if ($("#dicrionary").val() > 0) {
    } else {
      $("#dicrionary").val("");
      $("#default-dictionary").css("display", "block");
      $("#main-search-results2").css("display", "none");
    }

    e.preventDefault();
    const $target = $(e.currentTarget);
    const letter = $target.data("letter");
    let visibleCount = 0;
    function filterElements(letter) {
      $filterables.each((key, item) => {
        const name = $(item).data("name");
        if (name.toLowerCase().startsWith(letter)) {
          $(item).removeClass("is-hidden");

          visibleCount++;
        } else {
          $(item).addClass("is-hidden");
        }
      });
    }

    filterElements(letter);

    if (visibleCount <= 0) {
      $(noResultsElement).removeClass("is-hidden");
    } else {
      $(noResultsElement).addClass("is-hidden");
    }
    $(`${nav} .${BUTTON_ACTIVE_CLASS}`).removeClass(BUTTON_ACTIVE_CLASS);
    $target
      .parent()
      .addClass(BUTTON_ACTIVE_CLASS)
      .blur();
  }

  $elements.click(handleClick);
  window.addEventListener("load", function() {
    const name = $(".js-pricing-nav .js-pricing-nav-trigger");
    const first_letter = name.first().data("letter");

    function filterElements(first_letter) {
      $filterables.each((key, item) => {
        const name = $(item).data("name");
        if (name.toLowerCase().startsWith(first_letter)) {
          $(item).removeClass("is-hidden");
          // visibleCount++;
        } else {
          $(item).addClass("is-hidden");
        }
      });
    }

    filterElements(first_letter);
  });
}
